// Relocates the Restock Rocket "Notify me" button on collection cards into the
// theme's own .card__links slot and re-skins it with the theme's button classes,
// so out-of-stock cards get a hover-reveal pill in the same place/behaviour as
// Quick Add, instead of Restock Rocket's own static block under the price.
(function () {
  // Matches snippets/icon-bell.liquid, inlined because this markup is built
  // in JS (third-party button, not something Liquid renders into).
  var BELL_ICON_SVG =
    '<svg class="icon icon-bell" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 18 18" fill="none">' +
    '<path d="M11.8124 15.75C11.8124 15.8992 11.7532 16.0423 11.6477 16.1477C11.5422 16.2532 11.3991 16.3125 11.2499 16.3125H6.74992C6.60073 16.3125 6.45766 16.2532 6.35217 16.1477C6.24668 16.0423 6.18742 15.8992 6.18742 15.75C6.18742 15.6008 6.24668 15.4577 6.35217 15.3523C6.45766 15.2468 6.60073 15.1875 6.74992 15.1875H11.2499C11.3991 15.1875 11.5422 15.2468 11.6477 15.3523C11.7532 15.4577 11.8124 15.6008 11.8124 15.75ZM15.5959 12.3708C15.205 11.6986 14.6249 9.79664 14.6249 7.3125C14.6249 5.82066 14.0323 4.38992 12.9774 3.33502C11.9225 2.28013 10.4918 1.6875 8.99992 1.6875C7.50807 1.6875 6.07733 2.28013 5.02244 3.33502C3.96755 4.38992 3.37492 5.82066 3.37492 7.3125C3.37492 9.79734 2.79414 11.6986 2.4039 12.3708C2.30425 12.5417 2.25142 12.7358 2.25074 12.9336C2.25006 13.1315 2.30156 13.326 2.40003 13.4975C2.49851 13.6691 2.64049 13.8117 2.81165 13.9109C2.98281 14.0101 3.17709 14.0624 3.37492 14.0625H14.6249C14.8227 14.0622 15.0169 14.0098 15.1879 13.9106C15.359 13.8114 15.5009 13.6688 15.5993 13.4972C15.6977 13.3257 15.7491 13.1312 15.7484 12.9335C15.7477 12.7357 15.6949 12.5416 15.5952 12.3708H15.5959Z" fill="currentColor"/>' +
    '</svg>';

  function upgrade(button) {
    if (button.dataset.rrCardUpgraded) return;
    button.dataset.rrCardUpgraded = 'true';

    var cardWrapper = button.closest('.card-wrapper');
    var linksContainer = cardWrapper && cardWrapper.querySelector('.card__links');
    if (!linksContainer) return;

    var previous = linksContainer.querySelector('.card__add-to-cart--restock-rocket');
    if (previous) previous.remove();

    button.removeAttribute('style');
    button.classList.add('card__link', 'button', 'button--primary', 'card-focused');

    // Same text/icon split as the real Quick Add button (product-card.liquid),
    // so the same .card__quickadd-text / .card__mobile-icon breakpoint rules
    // swap this to an icon-only button under 750px too.
    var label = button.textContent.trim();
    button.textContent = '';

    var content = document.createElement('div');
    content.className = 'button__content';

    var textSpan = document.createElement('span');
    textSpan.className = 'card__quickadd-text button__label';
    textSpan.setAttribute('data-label', label);
    textSpan.textContent = label;

    var iconSpan = document.createElement('span');
    iconSpan.className = 'card__mobile-icon button__icon';
    iconSpan.innerHTML = BELL_ICON_SVG;

    content.appendChild(textSpan);
    content.appendChild(iconSpan);
    button.appendChild(content);

    var wrapper = document.createElement('div');
    wrapper.className = 'card__add-to-cart card__button card__add-to-cart--restock-rocket';
    wrapper.appendChild(button);
    linksContainer.appendChild(wrapper);
  }

  function scan(node) {
    if (node.nodeType !== 1) return;
    if (node.classList && node.classList.contains('restock-rocket-button-collection')) {
      upgrade(node);
    }
    if (node.querySelectorAll) {
      node.querySelectorAll('.restock-rocket-button-collection').forEach(upgrade);
    }
  }

  scan(document.body);

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(scan);
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
